import { useEffect } from 'react';
import { AudioDescriptions } from '@tmsw/powerups.services.audio-descriptions';

let audioDescInitialized = { current: false };

export function useInitAudioDesc() {
  useEffect(() => {
    let hasAudioDescInitListener = false;

    const initAudioDesc = () => {
      AudioDescriptions.speak(`     `, false);
    };
    if (!audioDescInitialized.current) {
      audioDescInitialized.current = true;
      hasAudioDescInitListener = true;
      document
        .querySelector('button')
        ?.addEventListener('click', initAudioDesc);
    }
    return () => {
      if (hasAudioDescInitListener) {
        document
          .querySelector('button')
          ?.removeEventListener('click', initAudioDesc);
      }
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
}
